import React, { useContext, useEffect, useRef, useState } from 'react'
import { VersionHistoryContext } from '../../context/versionHistoryContext';
import CloseCross from '../../assets/images/closeCross';
import { SpinnerIcon } from '../../assets/images/spinner';

const data = {
    copy: {
        title: "Copy Version",
        action: "Make a copy"
    },
    restore: {
        title: "Restore Version",
        action: "Restore"
    }
}

export const Modal = ({ type, onClose }) => {
    const { state, actions } = useContext(VersionHistoryContext)
    const ref = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handleCloseModal();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (type) {
            setIsSaving(false);
            setShowModal(true);
        }
    }, [type])

    const handleCloseModal = () => {
        setShowModal(false);
        onClose();
    }

    const handleClickAction = async () => {
        if (type === "copy" && name || type === "restore") {
            try {
                setIsLoading(true);
                setIsError(false);
                if (type === "copy") {
                    await actions.duplicate(name);
                } else if (type === "restore") {
                    await actions.restore();
                }
                setIsLoading(false);
                setIsSaving(true);
                setTimeout(() => {
                    setIsSaving(false);
                    handleCloseModal();
                }, 1500);
            } catch (error) {
                setIsLoading(false);
                setIsSaving(false);
                setIsError(true);
                setTimeout(() => {
                    setIsError(false);
                }, 2000);
            }
        }
    }

    const onInputChange = (e) => {
        setName(e.target.value)
    }

    if (showModal)
        return (
            <div className='version-history-modal' ref={ref}>
                <div>
                    <span>{data[type].title}</span>
                    <CloseCross onClick={handleCloseModal} />
                </div>
                {type === "copy" && (
                    <div>
                        <label>Name</label>
                        <input type='text' value={name} onChange={onInputChange} placeholder={`Copy of ${state.selectedVersion.flimp_title}`} />
                    </div>
                )}
                {type === "restore" && (
                    <div>
                        Your current document will revert to the version from {state.selectedVersion.formatedDate}. Are you sure?
                    </div>
                )}
                <div>
                    <div className='buttons'>
                        <button onClick={handleCloseModal}>Cancel</button>
                        <button className={`action ${type === "copy" && !name.length ? "disabled" : ""} ${isLoading ? "isLoading" : ""} ${isSaving ? "isSaving" : ""}`} onClick={handleClickAction}>
                            {
                                isSaving ?
                                    <div className="wrapperSaved">
                                        <SpinnerIcon />
                                    </div>
                                    :
                                    data[type].action
                            }
                        </button>
                    </div>
                    <div className='error'>{isError && "An error occurred, please try again."}</div>
                </div>
            </div>
        )
}
